import { Component, OnInit, ViewChild } from '@angular/core';

import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';
import { first } from 'rxjs/operators';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';
import { Table } from 'primeng/table';
import { TovpilCrudService } from 'src/app/utils/tovpil-crud-service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Constants } from 'src/app/shared/vo/Constants';
import { FiiConcept } from 'src/app/shared/models/FiiConcept';
import { ValuesVO } from 'src/app/shared/models/ValuesVO';

@Component({
  selector: 'app-fiiconcepts',
  templateUrl: './fiiconcepts.component.html',
  styleUrls: ['./fiiconcepts.component.scss'],
  providers: [MessageService, ConfirmationService]

})
export class FIIConceptsComponent implements OnInit {

  /** SECURITY */
  currentUser: any;
  security: SecurityDocument;
  token: string;
  device: string;
  storeId: string;

  /** LABELS */
  lbl_go_Back: string = "back_";
  lbl_language: string = "language_";
  lbl_workshop: string = "workshop_";
  lbl_schedule: string = "schedule_";
  lbl_participants: string = "participants_";
  lbl_new_record: string = "new_record_";
  lbl_name: string = "name_";
  lbl_cell_phone: string = "cell_phone_";
  lbl_email: string = "email_";
  lbl_gender: string = "gender_";
  lbl_edit: string = "edit_";
  lbl_delete: string = "delete_";
  lbl_search: string = "search_";
  lbl_particp15s: string = "10a15a_particip_";
  lbl_participants_12: string = "participants_";
  lbl_participants_1st: string = "participants_2nd_sesion_";
  lbl_future_guide: string = "future_guide_";
  lbl_partic_partner: string = "partic_partners_";
  lbl_no_sent: string = "no_sent_";
  lbl_age: string = "age_";
  lbl_school_prep_guides: string = "school_prep_guides_";
  lbl_comments: string = "comments_";
  lbl_date: string = "date_";
  lbl_save: string = "save_";
  lbl_guide_id: string = "guide_id_";
  lbl_certificate: string = "certificate_";
  lbl_change_Status_Guide_or_Comment: string = "change_Status_Guide_or_Comment";
  lbl_coordination: string = "coordination_";
  lbl_guideId: string = "guideId_";
  lbl_status: string = "status_";
  lbl_leaving_reason: string = "leaving_reason_";
  lbl_select: string = "select_";
  lbl_send: string = "send_";
  lbl_guide: string = "guide_";
  lbl_confirm: string = "confirm_";
  lbl_are_you_sure: string = "are_you_sure_";
  lbl_updated_data: string = "updated_data_";
  lbl_delete_record: string = "delete_record_";
  lbl_showing: string = "showing_";
  lbl_of: string = "of_";
  lbl_records: string = "records_";
  lbl_total: string = "total_";
  lbl_vendor: string = "vendor_";
  lbl_OR_vendor_quote: string = "OR_vendor_quote_";
  lbl_new: string = "new_";
  lbl_orders_request: string = "orders_request_";
  lbl_req_Date: string = "req_Date_";
  lbl_currency: string = "currency_";
  lbl_loading: string = "loading_";
  lbl_aprove_request_by_loc: string = "aprove_request_by_loc_";
  lbl_description: string = "description_";
  lbl_type: string = "type_";


  /** COMPONENT TABLE */
  @ViewChild('dt') table: Table;
  data: Record<string, any>[];
  cols: any[];
  endPointgetFiiconceptById = "listFiiconcept";
  endPointLanguageByStoreId = "getListSpkLangByStoreId";

  colsGlobal = ['concepId', 'conType', 'descrip', 'intAut', 'intVis',
    'localAut', 'localVis', 'natAut', 'natVis', 'orderLn', 'shrDesc', 'zonAut', 'zonVis'];
  colsFilter = [
    { name: 'concepId', value: 'concepId' },
    { name: 'conType', value: 'conType' },
    { name: this.lbl_description, value: 'descrip' },
    { name: 'intAut', value: 'intAut' },
    { name: 'intVis', value: 'intVis' },
    { name: 'orderLn', value: 'orderLn' },
    { name: 'shrDesc', value: 'shrDesc' },
  ];
  rowsPerPage: number = 10; // Cambia esto según tus necesidades


  /** COMPONENT OVERLAY */
  blocked: boolean = true;

  /** SEARCH FORM */
  dataForm: FormGroup;
  languagesLst: ValuesVO[];

  /**
   * This is a constructor function that initializes various services and variables used in the
   * component.
   * @param {MessageService} messageService - This parameter is of type MessageService and is used for
   * displaying messages to the user.
   * @param {PurchOrdSupLstService} purchOrdSupLstServiceTest - This parameter is an instance of the
   * PurchOrdSupLstService class. It is used to perform operations related to the purchase order
   * supplier list.
   * @param {ConfirmationService} confirmationService - This parameter is used to display confirmation
   * dialogs to the user. It is provided by the ConfirmationService class.
   * @param {ApiService} apiService - An instance of the ApiService class, which is responsible for
   * making API calls.
   * @param {Router} router - The `router` parameter is used for routing and navigation in Angular. It
   * allows you to navigate to different components and pass data between them.
   * @param {ActivatedRoute} route - The `route` parameter is used to access the current route's
   * information, such as the URL parameters and query parameters. It is an instance of the
   * `ActivatedRoute` class, which is provided by the Angular Router.
   * @param {AuthenticationService} authenticationService - This parameter is used to authenticate the
   * user and manage user-related functionalities such as login, logout, and user information.
   * @param {TovpilUtilsService} tovpilUtils - TovpilUtilsService is a service that provides utility
   * functions for the Tovpil application. It may include functions for formatting data, manipulating
   * strings, or performing common calculations.
   * @param {TovpilFilesService} filesService - TovpilFilesService is a service that handles file-related
   * operations such as uploading, downloading, and deleting files.
   */
  constructor(private messageService: MessageService,
    private apiService: ApiService,
    private router: Router,
    private route: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private filesService: TovpilFilesService,
    private tovpilCrudService: TovpilCrudService,
    private fb: FormBuilder) {

    this.dataForm = this.fb.group({
      data_language: [null],
    });

    this.route.queryParams.subscribe(
      params => {
        this.token = params.token;
        this.device = params.device;
        this.storeId = params.storeId;
      });

    if (this.token) {
      if (this.device && this.device == "2") {
        this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');
      }
    } else {
      this.currentUser = this.authenticationService.currentUserValue;
    }
  }

  /**
   * The ngOnInit function initializes the component by setting the currentUser value, fetching languages
   * and security information, and loading FII concepts.
   */
  ngOnInit(): void {
    this.currentUser = this.authenticationService.currentUserValue;
    this.getSecurity();
  }

  /**
  * The function `autenthicateByZuul` authenticates a user by calling the `login` method of the
  * `authenticationService` and then performs additional actions based on the response.
  * @param {string} user - A string representing the username or user identifier.
  * @param {string} password - The `password` parameter is a string that represents the user's password.
  */
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 'R-0200') {
            this.getSecurity();
          } else {
          }
        },
        error => {
        });
  }

  /**
   * The function `getSecurity()` retrieves security data and then calls another function to get
   * translated labels.
   */
  getSecurity() {
    if (!this.security) {
      this.apiService.findSecurityById({ "id": this.currentUser.tokenProfile }).then(
        data => {
          this.security = data;
          this.getTranslatedLabels();
        });
    } else {
      this.getTranslatedLabels();
    }
  }

  /**
   * The function "getLanguages" initializes an array of language objects with their labels and values.
   */
  getLanguages() {
    //console.debug(this.security)
    this.tovpilCrudService.fetch(this.endPointLanguageByStoreId, {
      "language": this.security!.language || null,
      "storeId": this.security!.storeId || null
    }).then(result => {
      if (result.success) {
        //console.debug("Lenguajes: ", result.data);
        this.languagesLst = result.data;
        if (this.security.language) {
          this.dataForm.patchValue({
            data_language: this.languagesLst.find(o => o.valueId == this.security.language)
          });
          this.loadData();
        }
      } else {
        console.error("An error occurred while fetching purchase order data:");
        this.handleError("Hubo un problema, no hay información que obtener para lenguajes. Por favor, recargue la página e inténtelo nuevamente más tarde.");
      }
    }).catch(error => {
      console.error("An error occurred while fetching purchase order data:");
      this.handleError("Hubo un problema, no hay información que obtener para lenguajes. Por favor, recargue la página e inténtelo nuevamente más tarde.");
    });
  }

  /**
   * The function `getLstDataByMenuOption` sets default values for parameters, parses values from a form,
   * and retrieves a list of data based on the language parameter.
   * @param {any} paramsToSet - An object containing parameters to set. If not provided, it will use
   * default values.
   */


  /**
   * The `loadData` function checks if the `dataForm` is valid, and if so, it calls the
   * `getLstDataByMenuOption` function with the selected language. If the `dataForm` is not valid, it
   * displays an error message.
   * @param {Event} event - The event parameter is an object that contains information about the event
   * that triggered the loadData function. It is typically an event object that is passed from the UI
   * when a certain action occurs, such as a button click or a form submission. In this case, it seems to
   * contain a 'value' property that
   */
  loadData() {
    if (this.dataForm.valid) {
      //console.debug("Formulario lenguaje", this.dataForm.value),
      this.fetch(); // VALIDAR A  CAMBIAR EN BASE A IDIOMA
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Datos Invalidos, Por favor ingreese los datos solicitados!',
        life: 5000
      });
    }
  }

  /**
   * The fetch function makes an HTTP request to fetch data and handles the success and error cases.
   * @param {any} requestParams - The requestParams parameter is an object that contains the parameters
   * to be sent with the fetch request. These parameters could include things like query strings,
   * headers, or body data.
   */
  fetch() {
    this.blocked = true;
    this.apiService.listFiiconcept({
      "lang": (this.dataForm.get('data_language').value).valueId
    }).then(
      data => {
        this.handleSuccess(data);
      }).catch(error => {
        console.error("An error occurred while fetching purchase order data:");
        this.handleError("Hubo un problema, no hay información que procesar. Por favor, recargue la página e inténtelo nuevamente más tarde.");
      }).finally(() => {
        setTimeout(() => {
          this.blocked = false;
        }, 1500);
      });
  }

  /**
   * The handleSuccess function handles the successful response from an API call by extracting columns
   * from the JSON data, assigning the data to an array, and calculating the number of rows per page.
   * @param {any[]} data - An array of data that needs to be processed.
   */
  handleSuccess(data: any[]) {
    if (data.length > 0) {
      // Extraer dinámicamente las columnas del JSON
      this.cols = this.tovpilCrudService.extractColumns(data[0], undefined, this.colsFilter);
      // Asignar los datos al arreglo de productos
      this.data = data;
      // Asignar el número de filas por página dinámicamente
      this.rowsPerPage = this.tovpilCrudService.calculateRowsPerPage(data.length, this.rowsPerPage);
    } else {
      this.data = null;
      this.cols = null;
      this.handleError("Hubo un problema, no hay información que procesar. Por favor, recargue la página e inténtelo nuevamente más tarde.");
    }
    //console.debug(this.data);
    //console.debug(this.cols);
  }

  /**
   * The handleError function logs an error message to the console and adds an error message to the
   * message service.
   * @param {string} message - The `message` parameter is a string that represents the error message that
   * occurred while parsing.
   */
  handleError(message: string) {
    console.error("An error occurred while parsing.");
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: message,
      life: 5000
    });
  }

  /**
   * The function `capitalizeLastElement` takes a string as input and returns the same string with the
   * last element capitalized.
   * @param {string} str - The parameter `str` is a string that represents the input string.
   * @returns the result of calling the `capitalizeLastElement` method of the `tovpilCrudService` object
   * with the `str` parameter.
   */
  capitalizeLastElement(str: string): string {
    return this.tovpilCrudService.capitalizeLastElement(str);
  }

  /**
   * The function `getNestedValue` retrieves a nested value from an object using a specified field.
   * @param {any} obj - The `obj` parameter is an object from which you want to retrieve a nested value.
   * @param {string} field - The `field` parameter is a string that represents the path to the nested
   * value in the `obj` object.
   * @returns The `getNestedValue` function is returning the result of the
   * `tovpilCrudService.getNestedValue` method.
   */
  getNestedValue(obj: any, field: string): any {
    return this.tovpilCrudService.getNestedValue(obj, field);
  }

  /**
   * The goBack function closes the current window.
   */
  goBack() {
    window.close();
  }

  /**
   * The function `getTranslatedLabels` retrieves translated labels from an API and assigns them to
   * corresponding variables.
   */
  getTranslatedLabels() {
    let map = new Map();
    let lstRespTranslate: TranslateRelLabelVO[];
    this.apiService.listByLanguageMultFields({
      'language': this.security.language,
      'region': this.security.region,
      'lstLabels': [this.lbl_go_Back, this.lbl_language, this.lbl_schedule, this.lbl_participants, this.lbl_new_record, this.lbl_name, this.lbl_cell_phone, this.lbl_email, this.lbl_gender, this.lbl_edit, this.lbl_delete, this.lbl_search, this.lbl_particp15s, this.lbl_participants_12, this.lbl_participants_1st, this.lbl_future_guide, this.lbl_partic_partner, this.lbl_no_sent, this.lbl_age, this.lbl_workshop, this.lbl_school_prep_guides, this.lbl_comments, this.lbl_date, this.lbl_save, this.lbl_guide_id, this.lbl_certificate, this.lbl_change_Status_Guide_or_Comment, this.lbl_coordination, this.lbl_guideId, this.lbl_status, this.lbl_leaving_reason, this.lbl_select, this.lbl_send, this.lbl_guide, this.lbl_confirm, this.lbl_are_you_sure, this.lbl_updated_data, this.lbl_delete_record, this.lbl_showing, this.lbl_of, this.lbl_records, this.lbl_total, this.lbl_vendor, this.lbl_OR_vendor_quote, this.lbl_new, this.lbl_orders_request, this.lbl_req_Date, this.lbl_currency, this.lbl_loading, this.lbl_aprove_request_by_loc, this.lbl_description, this.lbl_type]
    }).then(
      trDocs => {
        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });
        this.lbl_go_Back = map.get(this.lbl_go_Back);
        this.lbl_language = map.get(this.lbl_language);
        this.lbl_schedule = map.get(this.lbl_schedule);
        this.lbl_participants = map.get(this.lbl_participants);
        this.lbl_new_record = map.get(this.lbl_new_record);
        this.lbl_name = map.get(this.lbl_name);
        this.lbl_cell_phone = map.get(this.lbl_cell_phone);
        this.lbl_email = map.get(this.lbl_email);
        this.lbl_gender = map.get(this.lbl_gender);
        this.lbl_edit = map.get(this.lbl_edit);
        this.lbl_delete = map.get(this.lbl_delete);
        this.lbl_search = map.get(this.lbl_search);
        this.lbl_particp15s = map.get(this.lbl_particp15s);
        this.lbl_participants_12 = map.get(this.lbl_participants_12);
        this.lbl_participants_1st = map.get(this.lbl_participants_1st);
        this.lbl_future_guide = map.get(this.lbl_future_guide);
        this.lbl_partic_partner = map.get(this.lbl_partic_partner);
        this.lbl_no_sent = map.get(this.lbl_no_sent);
        this.lbl_age = map.get(this.lbl_age);
        this.lbl_workshop = map.get(this.lbl_workshop);
        this.lbl_school_prep_guides = map.get(this.lbl_school_prep_guides);
        this.lbl_comments = map.get(this.lbl_comments);
        this.lbl_date = map.get(this.lbl_date);
        this.lbl_save = map.get(this.lbl_save);
        this.lbl_certificate = map.get(this.lbl_certificate);
        this.lbl_guide_id = map.get(this.lbl_guide_id);
        this.lbl_change_Status_Guide_or_Comment = map.get(this.lbl_change_Status_Guide_or_Comment);
        this.lbl_coordination = map.get(this.lbl_coordination);
        this.lbl_guideId = map.get(this.lbl_guideId);
        this.lbl_status = map.get(this.lbl_status);
        this.lbl_leaving_reason = map.get(this.lbl_leaving_reason);
        this.lbl_select = map.get(this.lbl_select);
        this.lbl_send = map.get(this.lbl_send);
        this.lbl_guide = map.get(this.lbl_guide);
        this.lbl_confirm = map.get(this.lbl_confirm);
        this.lbl_are_you_sure = map.get(this.lbl_are_you_sure);
        this.lbl_updated_data = map.get(this.lbl_updated_data);
        this.lbl_delete_record = map.get(this.lbl_delete_record);
        this.lbl_showing = map.get(this.lbl_showing);
        this.lbl_of = map.get(this.lbl_of);
        this.lbl_records = map.get(this.lbl_records);
        this.lbl_total = map.get(this.lbl_total);
        this.lbl_vendor = map.get(this.lbl_vendor);
        this.lbl_OR_vendor_quote = map.get(this.lbl_OR_vendor_quote);
        this.lbl_new = map.get(this.lbl_new);
        this.lbl_orders_request = map.get(this.lbl_orders_request);
        this.lbl_req_Date = map.get(this.lbl_req_Date);
        this.lbl_currency = map.get(this.lbl_currency);
        this.lbl_loading = map.get(this.lbl_loading);
        this.lbl_aprove_request_by_loc = map.get(this.lbl_aprove_request_by_loc);
        this.lbl_description = map.get(this.lbl_description);
        this.lbl_type = map.get(this.lbl_type);
      });
    this.getLanguages();
  }

  /**
   * The function sets the default value for the "data_language" field in a form using the value provided
   * in the "language" parameter.
   * @param {any} params - The `params` parameter is an object that contains key-value pairs. In this
   * case, it is expected to have a key called 'language' which represents the language value that needs
   * to be set as the default value for the 'data_language' field in the `dataForm`.
   */
  setDefaultValues(params: any) {
    this.dataForm.patchValue({
      data_language: params['language']
    });
  }

  /**
   * The function "parsingValues" parses form values and returns an object with the language value.
   * @param {any} formValues - The `formValues` parameter is an object that contains the values submitted
   * from a form.
   * @returns an object with a key "language" and a value that is either the value of
   * formValues['data_language'] if it is not null, or null if it is null.
   */
  parsingValues(formValues: any) {
    return {
      "language": formValues['data_language'] == null ? null : formValues['data_language'],
    }
  }

  /**
   * The function "openNew" initializes some variables and sets a flag to indicate that a dialog should
   * be displayed.
   */
  openNew() {
    this.redirectToDtl('C', this.security, null);
  }

  /**
   * The function `editFiiConcepts` takes a `FiiConcept` object as a parameter, converts it to JSON
   * format, assigns it to a temporary variable, and sets some flags for further processing.
   * @param {FiiConcept} fiiConceptsTemp - The parameter `fiiConceptsTemp` is of type `FiiConcept`, which
   * is an object representing a concept related to FII (Fundo de Investimento Imobiliário) in the code.
   */
  editFiiConcepts(fiiConceptsTemp: FiiConcept) {
    let arrayOfFiiConcepts: FiiConcept[] = [fiiConceptsTemp];
    fiiConceptsTemp = this.convertPropertiesToJsonFormat(arrayOfFiiConcepts)[0];
    this.redirectToDtl('U', this.security, fiiConceptsTemp);
  }

  /**
   * The function `redirectToDtl` takes in three parameters (_opt, _security, _data) and navigates to a
   * specific route with the provided parameters.
   * @param {string} _opt - A string representing the option or action to be performed.
   * @param {any} _security - The `_security` parameter is an object that represents the security
   * information for the navigation. It could contain properties such as authentication tokens, user
   * roles, or any other security-related data that needs to be passed along with the navigation.
   * @param {any} _data - The `_data` parameter is an object that contains additional data that needs to
   * be passed to the destination page.
   */
  redirectToDtl(_opt: string, _security: any, _data: any) {
    let obj = {
      security: _security,
      opt: _opt,
      data: _data
    }

    let navigationExtras: NavigationExtras = {
      state: JSON.parse(JSON.stringify(obj))
    }

    this.router.navigate(['/catalogs/fIIConceptsDtl'], navigationExtras);
  }

  /**
   * The function converts properties of FiiConcept objects into JSON format by mapping specific values
   * to labels.
   * @param {FiiConcept[]} fiiConceptList - An array of FiiConcept objects.
   * @returns The function `convertPropertiesToJsonFormat` returns the `fiiConceptList` array after
   * modifying its elements by adding `visList` and `autList` properties.
   */
  convertPropertiesToJsonFormat(fiiConceptList: FiiConcept[]) {
    const autMappings = {
      intAut: { label: 'INT AUT', value: 'intAut' },
      zonAut: { label: 'ZONE AUT', value: 'zonAut' },
      natAut: { label: 'NATIONAL AUT', value: 'natAut' },
      localAut: { label: 'LOCAL AUT', value: 'localAut' }
    };

    const visMappings = {
      intVis: { label: 'INT VIS', value: 'intVis' },
      zonVis: { label: 'ZONE VIS', value: 'zonVis' },
      natVis: { label: 'NATIONAL VIS', value: 'natVis' },
      localVis: { label: 'LOCAL VIS', value: 'localVis' }
    };

    fiiConceptList.forEach(fiiConcept => {
      fiiConcept.visList = [];
      fiiConcept.autList = [];

      for (const [key, mapping] of Object.entries(autMappings)) {
        if (String(fiiConcept[key]) === "1") {
          fiiConcept.autList.push(mapping);
        }
      }

      for (const [key, mapping] of Object.entries(visMappings)) {
        if (String(fiiConcept[key]) === "1") {
          fiiConcept.visList.push(mapping);
        }
      }
    });

    return fiiConceptList;
  }

  /**
   * The exportExcel function exports data to an Excel file if there is data available, otherwise it
   * displays an error message.
   */
  exportExcel() {
    if (this.data === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.data.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.data.map((item) => {
        const dynamicColumns = this.colsFilter.map((col) => ({
          [col.name]: item ? this.tovpilCrudService.getNestedValue(item, col.value) || 'S/N' : 'S/N'
        }));
        return Object.assign({}, ...dynamicColumns);
      });
      this.filesService.tovpilExportXLSX(filteredJSON, 'fiiConcepts_');
    }
  }

  /**
   * The `exportPdf()` function exports data to a PDF file if the data is not null and the list is not
   * empty, otherwise it displays an error message.
   */
  exportPdf() {
    if (this.data === null) {
      this.messageService.add({
        severity: 'error',
        summary: 'No existe información para procesar',
        life: 3000
      });
    } else if (this.data.length < 1) {
      this.messageService.add({
        severity: 'error',
        summary: 'La lista está vacía',
        life: 3000
      });
    } else {
      const filteredJSON = this.data.map((item) => {
        const dynamicColumns = this.colsFilter.map((col) => ({
          [col.name]: item ? this.tovpilCrudService.getNestedValue(item, col.value) || 'S/N' : 'S/N'
        }));
        return Object.assign({}, ...dynamicColumns);
      });
      const keysArray = filteredJSON.map((item) => Object.keys(item));
      const valuesArray = filteredJSON.map((item) => Object.values(item));
      this.filesService.tovpilExportPDF(keysArray[0], valuesArray, 'fiiConcepts_');
    }
  }
}
